<template>
  <div>
    <MyAccountsItem v-for="(account,i) in accounts" :key="i"
                    :item="account"
                    :selected="(!!account_selected && account_selected.id === account.id)"
                    @selectAcc="$emit('selectAcc', $event)"/>
  </div>
</template>

<script>
import MyAccountsItem from "@/components/cabinet/Money/Dashboard/MyAccounts/MyAccountsItem";
import {mapState} from "vuex";

export default {
  name: "MyAccountsItemsRows",
  components: {MyAccountsItem},
  props: {
    accounts: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapState('moneyDashboard/recentTransactions', ['account_selected']),
  }
}
</script>

<style scoped>

</style>